export const OAUTH_PROVIDERS = Object.freeze({
  NAVER: 'naver',
  KAKAO: 'kakao',
  GOOGLE: 'google',
});

export const OAUTH_PROVIDERS_KOREAN = Object.freeze({
  naver: '네이버',
  kakao: '카카오',
  google: '구글',
});